import { css } from '@emotion/react';
import NvModal, { BackdropType, ModalType, NvModalProps } from 'shared/components/nv-modal';
import TopGradientBorder from './top-gradient-border';

type AiModalProps = Omit<NvModalProps, 'type'>;

export const lhsModalStyles = css`
  .modal-page {
    max-width: 1040px;
    overflow-y: auto;
    right: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;
  }
  .close {
    top: 0;
    right: 0;
  }
`;

const AiModal = (props: AiModalProps) => {
  const { show, onClose, body, modalStyles, ...restProps } = props;

  return (
    <NvModal
      show={show}
      fullHeight={false}
      type={ModalType.NO_DIALOG}
      onClose={onClose}
      modalStyles={css([lhsModalStyles, modalStyles])}
      backdropType={BackdropType.DEFAULT}
      body={(
        <div className='modal-page'>
          <TopGradientBorder />
          {body}
        </div>
      )}
      {...restProps}
    />
  );
};

export default AiModal;
